export const EMPHASIZE_DROP_AREA = 'EMPHASIZE_DROP_AREA';
export const DEEMPHASIZE_DROP_AREA = 'DEEMPHASIZE_DROP_AREA';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/constants/event_names.ts